import { Component, OnInit } from "@angular/core";
import * as ldash from "lodash";

import { VisitorService } from "../visitor/service/api/visitor.service";
import { GLOBAL_CONSTANT } from "./../common/constant/global.constant";
import * as _ from "underscore";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-visitor-chart",
  templateUrl: "./visitor-chart.component.html",
  styleUrls: ["./visitor-chart.component.scss"],
})
export class VisitorChartComponent implements OnInit {
  data: any;
  options: any;
  visitorCount: any;
  visitorData: any;
  weeks: any;
  currentDate: any;
  startdate: any;
  endDate: any;
  startLimit: any;
  endLimit: any;
  weekCountVisistor: number;
  currentWeekLabel: string;
  visitorPerWeek: number;
  weekDays: any;
  visitorDay: any;

  dateFormat = { day: "numeric", month: "numeric", year: "numeric" };
  todaysDateFormat = { day: "numeric", month: "short", year: "numeric" };
  dateLabelFormat = { day: "numeric", weekday: "short" };
  todaysDate: any;

  constructor(
    public datepipe: DatePipe,
    private visitorService: VisitorService
  ) {
    this.weekDays = GLOBAL_CONSTANT.WEEK_DAYS;
  }

  getVisitorList() {
    this.visitorService.getAllVisitorsEntry().subscribe((data) => {
      let resp: any = [];
      resp = data;
      this.visitorData = resp.filter(
        (data) => data.purposeCategory == "GENERAL_VISIT"
      );

      this.currentDate = new Date();
      this.startdate = new Date().setDate(this.currentDate.getDate() - 7);
      this.endDate = this.currentDate;
      this.startLimit = this.formatDate(
        this.visitorData[0].createdDate,
        this.dateFormat
      );
      this.endLimit = this.formatDate(
        this.visitorData[this.visitorData.length - 1].createdDate,
        this.dateFormat
      );
      this.generateChartData();
    });
  }

  generateChartData() {
    let weekData = this.getWeekData(
      this.startdate,
      this.endDate,
      this.visitorData
    );
    this.visitorPerWeek = 0;
    let weekGroup = ldash.groupBy(weekData, (value) => {
      return this.formatDate(value.createdDate, this.dateLabelFormat);
    });
    ldash.map(weekGroup, (value) => {
      this.visitorPerWeek += value.length;
    });
    let weekLabels = Object.keys(weekGroup);
    if (
      weekLabels.indexOf(
        this.formatDate(this.currentDate, this.dateLabelFormat)
      ) != -1
    ) {
    } else {
      let d = new Date(this.startdate);
      let labelStart = this.datepipe.transform(
        d.setDate(d.getDate() + 1),
        "dd/MM/yyyy"
      );
      this.currentWeekLabel = `${labelStart} - ${this.datepipe.transform(
        this.endDate,
        "dd/MM/yyyy"
      )}`;
    }
    let weekCounts = ldash.map(weekGroup, (value) => value.length);
    this.setChartData(weekLabels, weekCounts);
  }

  previous() {
    if (new Date(this.startdate) <= new Date(this.startLimit)) {
      return;
    }
    this.startdate = this.substractDays(this.startdate);
    this.endDate = this.substractDays(this.endDate);
    this.generateChartData();
  }

  preBtnDisable() {
    if (new Date(this.startdate) <= new Date(this.startLimit)) {
      return true;
    } else {
      return false;
    }
  }

  nextBtnDisable() {
    if (new Date(this.startdate) <= new Date(this.startLimit)) {
      return true;
    } else {
      return false;
    }
  }

  next() {
    if (new Date(this.endDate) >= new Date(this.endLimit)) {
      return;
    }
    this.startdate = this.addDays(this.startdate);
    this.endDate = this.addDays(this.endDate);
    this.generateChartData();
  }

  getWeekData(start, end, object) {
    let s = new Date(start);
    let e = new Date(end);
    let result = ldash.filter(object, (value) => {
      return (
        new Date(value.createdDate) >= s && new Date(value.createdDate) <= e
      );
    });
    return result;
  }

  setChartData(labels, count) {
    this.data = {
      labels: labels,
      datasets: [
        {
          data: count,
          fill: true,
          borderColor: "#4bc0c0",
          backgroundColor: "#DEF9EB",
          borderCapStyle: "square",
          borderWidth: "2px",
          pointBackgroundColor: "#5FE3A1",
        },
      ],
    };

    this.options = {
      title: {
        display: false,
        text: "My Title",
        fontSize: 16,
      },
      legend: {
        position: "bottom",
        display: false,
        labels: {
          fontColor: "#808495",
        },
      },
      scales: {
        yAxes: [
          {
            display: false,
            ticks: {
              beginAtZero: true,
              max: 10, // minimum value will be 0.
            },
          },
        ],
      },
    };
  }

  formatDate(date, format) {
    // {  day : 'numeric' ,month : "numeric", year : "numeric" }
    return new Date(date).toLocaleDateString("default", format);
  }

  substractDays(date) {
    let d = new Date(date);
    d.setDate(d.getDate() - 7);
    return new Date(d);
  }

  addDays(date) {
    let d = new Date(date);
    d.setDate(d.getDate() + 7);
    return new Date(d);
  }

  ngOnInit() {
    this.getVisitorList();
    this.todaysDate = new Date().toLocaleDateString(
      "default",
      this.todaysDateFormat
    );
    let day = new Date(this.todaysDate).getDay();
    this.visitorDay = _.find(this.weekDays, (a) => {
      return a.value === day;
    });
  }
}
